<div class="modal fade p-0 group-class-save" id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog modal-full-screen">
        <div class="modal-content save-class-text">
            <div class="modal-body">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container-fluid mt-2 p-0">

                    <bcu-local-spinner [size]="25" [visible]="!isLoaded" *ngIf="!isLoaded"></bcu-local-spinner>

                    <form [formGroup]="classForm" *ngIf="isLoaded">

                        <div class="row">
                            <div class="col">
                                <div class="switch-container"
                                    [ngClass]="{'switch-container-shadow': classForm.controls.isOnline.value}">
                                    <ui-switch class="ml-2 switch" [checked]="classForm.controls.isOnline.value"
                                        (change)="onOnlineChanged($event)" switchColor="#689F38"
                                        switchOffColor="#FFFFFF" size="small" color="#8BC34A"
                                        [disabled]="isOnlineDisabled">
                                    </ui-switch><span class="check-text" [ngClass]="{'text-dimmed' : isOnline}"
                                        style="margin-left: 8px;">{{'GroupClassSave.OnlineLabel' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="booking-container" *ngIf="isOnline">
                            <div class="row capacity-row no-gutters">
                                <div class="col-4 mt-21-px mx-3">
                                    <div class="form-group">
                                        <label
                                            for="streamingService">{{'GroupClassSave.StreamingServiceLabel' | translate}}</label>
                                        <bcu-drop-down-cf2 id="streamingService" formControlName="streamingService"
                                            class="control-height" [options]="context.streamingServices" valueKey="code"
                                            displayKey="name"
                                            [placeHolder]="'GroupClassSave.StreamingServicePlaceholder' | translate"
                                            [sortItems]="true">
                                        </bcu-drop-down-cf2>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-9-px">
                                <div class="col mx-3 pr-3">
                                    <div class="form-group">
                                        <label for="streamUrl">{{'GroupClassSave.LinkLabel' | translate}}</label>
                                        <input type="text" id="streamUrl" class="form-control control-height"
                                            maxlength="2000" [formControl]="classForm.controls['streamUrl']"
                                            [placeholder]="'GroupClassSave.LinkPlaceholder' | translate" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-6 pr-12-px">
                                <div class="form-group">
                                    <label for="clubId">{{'GroupClassSave.ClubLabel' | translate}}</label>
                                    <bcu-drop-down-cf2 id="clubId" formControlName="clubId" class="control-height"
                                        [options]="clubs" valueKey="id" displayKey="shortName"
                                        [placeHolder]="'GroupClassSave.ClubPlaceholder' | translate" [sortItems]="true"
                                        [isDisabled]="isClubDisabled" maxHeigth="450">
                                    </bcu-drop-down-cf2>
                                </div>
                            </div>
                            <div class="col-6 pl-12-px">
                                <div class="form-group">
                                    <label for="category">{{'GroupClassSave.CategoryLabel' | translate}}</label>
                                    <bcu-group-drop-down id="category" [formControl]="classForm.controls['category']"
                                        [options]="categories" valueKey="code" displayKey="name"
                                        groupByKey="classTypeName" maxHeigth="450" class="control-height"
                                        [isDisabled]="isCategoriesDisabled"
                                        [placeHolder]="'GroupClassSave.CategoryPlaceholder' | translate"
                                        [sortItems]="true"></bcu-group-drop-down>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="name">{{'GroupClassSave.NameLabel' | translate}}</label>
                                    <input id="name" formControlName="name" [typeahead]="existingNames"
                                        [typeaheadOptionsLimit]="10" [typeaheadMinLength]="1"
                                        class="form-control control-height" maxlength="200" autocomplete="off"
                                        [placeholder]="'GroupClassSave.ClassNamePlaceholder' | translate">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-12-px">
                                <div class="form-group">
                                    <label for="location">{{'GroupClassSave.DetailedLocationLabel' |translate}}</label>
                                    <bcu-group-drop-down maxHeigth="450"
                                        [placeHolder]="'GroupClassSave.DetailedLocationPlaceholder' | translate"
                                        [formControl]="classForm.controls['locationId']" [multiple]="false"
                                        groupByKey="type" [options]="clubLocations" valueKey="id" displayKey="name"
                                        [displayGroupFunc]="locationGroupDisplayNameFunc">
                                    </bcu-group-drop-down>
                                </div>
                            </div>
                            <div class="col-6 pl-12-px save-class">
                                <label for="instructor-search">{{'GroupClassSave.InstructorName' | translate}}</label>
                                <app-instructor-search-component id="instructor-search" class="control-height"
                                    (instructorSelected)="onInstructorSelectedSelected($event)"
                                    [clubIds]="clubId | singleItemArray"
                                    [selectedInstructorModel]="selectedInstructorModel" [dropDownWidth]="500">
                                </app-instructor-search-component>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="description">{{'GroupClassSave.DescriptionLabel' | translate}}</label>
                                    <textarea rows="3" type="text" id="description" class="form-control"
                                        [formControl]="classForm.controls['description']" maxlength="2000"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-4 pr-11-px">
                                <div class="form-group" class="position-relative">
                                    <span *ngIf="selectedDateIsFromThePast && !isEdit" class="ic-warning"
                                        placement="bottom" container="body"
                                        tooltip="{{'GroupClassSave.AddingClassInThePast' | translate}}"></span>
                                    <span *ngIf="selectedDateIsFromThePast && isEdit" class="ic-warning"
                                        placement="bottom" container="body"
                                        tooltip="{{'GroupClassSave.EditingClassInThePast' | translate}}"></span>
                                    <label for="classDate">{{'GroupClassSave.DateLabel' | translate}}</label>
                                    <bcu-drop-down-button-cf2 class="control-height"
                                        [invalid]="!classForm.controls['classDate'].valid && classForm.controls['classDate'].touched"
                                        [text]="classForm.controls['classDate'].value | bcDate"
                                        (click)="datePicker.toggle($event)"></bcu-drop-down-button-cf2>
                                    <bcu-date-select id="classDate" #datePicker [canSelectPastDates]="true"
                                        [formControl]="classForm.controls['classDate']"></bcu-date-select>
                                </div>
                            </div>
                            <div class="col-4 pr-11-px pl-11-px">
                                <div class="form-group">
                                    <label
                                        for="timeFromInMinutes">{{'GroupClassSave.StartTimeLabel' | translate}}</label>
                                    <bcui-time-picker formControlName="timeFromInMinutes" [pickerWidth]="140"
                                        class="control-height">
                                    </bcui-time-picker>
                                </div>
                            </div>

                            <div class="col-4 pl-11-px">
                                <div class="form-group" *ngIf="showTimePicker === false">
                                    <label
                                        for="durationTimeInMinutes">{{'GroupClassSave.DurationLabel' | translate}}</label>

                                    <bcu-drop-down-cf2 id="durationTimeInMinutes" class="control-height"
                                        [formControl]="classForm.controls['durationTimeInMinutes']"
                                        [options]="durationTimeInMinutesOptions" valueKey="value" displayKey="label"
                                        [isDisabled]="false" [required]="true" [sortItems]="true">
                                    </bcu-drop-down-cf2>

                                </div>

                                <div class="form-group" *ngIf="showTimePicker === true">
                                    <label for="timeToInMinutes">{{'GroupClassSave.EndTimeLabel' | translate}}</label>

                                    <bcui-time-picker formControlName="timeToInMinutes" [pickerWidth]="140"
                                        class="control-height">
                                    </bcui-time-picker>

                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="timeToInMinutes">{{'GroupClassSave.RecurringLabel' | translate}}</label>
                                    <bc-recurring formControlName="recurring" [disabled]="!startDateSelected"
                                        [startDate]="classForm.controls['classDate'].value"></bc-recurring>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col pr-12-px">
                                <div class="form-group" *ngIf="showTimePicker === false">
                                    <label
                                        for="billableTimeInMinutes">{{'GroupClassSave.BillableTimeLabel' | translate}}</label>

                                    <bcu-drop-down-cf2 id="billableTimeInMinutes" class="control-height"
                                        [formControl]="classForm.controls['billableTimeInMinutes']"
                                        [options]="billableTimeInMinutesOptions" valueKey="value" displayKey="label"
                                        [isDisabled]="false" [required]="true" [sortItems]="true">
                                    </bcu-drop-down-cf2>
                                </div>

                                <div class="form-group" *ngIf="showTimePicker === true">
                                    <label
                                        for="billableTimeInMinutes">{{'GroupClassSave.BillableTimeLabel' | translate}}</label>

                                    <div class="row no-gutters">
                                        <div class="col billable-input">
                                            <input type="number" id="billableTimeInMinutes" numbersOnly="9999" min="0"
                                                step="1" max="9999" formControlName="billableTimeInMinutes"
                                                class="form-control d-inline-block control-height">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col">
                                <app-checkbox [formControl]="classForm.controls['isVisibleToConnect']"
                                    [label]="'GroupClassSave.IsVisibleLabel' | translate"></app-checkbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="switch-container"
                                    [ngClass]="{'switch-container-shadow': classForm.controls.isFeeBased.value}">
                                    <ui-switch class="ml-2 switch" [checked]="classForm.controls.isFeeBased.value"
                                        (change)="onFeeBasedChanged($event)" switchColor="#689F38"
                                        switchOffColor="#FFFFFF" size="small" color="#8BC34A">
                                    </ui-switch><span class="check-text" [ngClass]="{'text-dimmed' : isFeeBased}"
                                        style="margin-left: 8px;">{{'GroupClassSave.FeeBased' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isFeeBased" class="booking-container">
                            <div class="row capacity-row no-gutters">
                                <div class="col label mb-3 p-3">
                                    <label for="fee">{{'GroupClassSave.FeeAmount' | translate}}</label>
                                    <span id="fee" class="input-symbol-currency">
                                        <input [mask]="mask.currencyMask" type="text" class="form-control"
                                            formControlName="fee" (change)="onFeeChanged($event)" />
                                    </span>
                                </div>
                            </div>
                            <div class="row capacity-row no-gutters mt-3">

                                <div class="col mb-3 p-3">
                                    <label
                                        for="revenueDepartmentCode">{{'GroupClassSave.RevenueDepartment' | translate}}</label>

                                    <bcu-drop-down-cf2 id="revenueDepartmentCode" dropdown dropdown-append-to-body
                                        [formControl]="classForm.controls['revenueDepartmentCode']" [showSearch]="true"
                                        [options]="revenueDepartments" valueKey="code" displayKey="name" maxHeigth="450"
                                        class="control-height py-10 revenue-department-dropdown" [sortItems]="true"></bcu-drop-down-cf2>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="switch-container"
                                    [ngClass]="{'switch-container-shadow': classForm.controls.isBookingRequired.value}">
                                    <ui-switch class="ml-2 switch"
                                        [checked]="classForm.controls.isBookingRequired.value"
                                        (change)="onBookingRequiredChanged($event)" switchColor="#689F38"
                                        switchOffColor="#FFFFFF" size="small" color="#8BC34A"
                                        [disabled]="isBookingRequiredDisabled">
                                    </ui-switch><span class="check-text" [ngClass]="{'text-dimmed' : isBookingRequired}"
                                        style="margin-left: 8px;">{{'GroupClassSave.BookingRequiredLabel' | translate}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="booking-container" *ngIf="isBookingRequired">
                            <div class="row capacity-row no-gutters">
                                <div class="col-auto mt-21-px mx-3">
                                    <div class="form-group">
                                        <label for="capacity">{{'GroupClassSave.CapacityLabel' | translate}}</label>
                                        <input id="capacity" class="form-control capacity-input control-height"
                                            [formControl]="classForm.controls['capacity']" type="number" min="1"
                                            step="1" max="99999" numbersOnly="99999"
                                            [readonly]="!isBookingRequired || isBookingRequiresSpecificResource"
                                            [ngClass]="{'is-disabled': isBookingRequiresSpecificResource}" />
                                    </div>
                                </div>
                                <div class="col d-flex align-items-center"
                                    *ngIf="isBookingRequiresSpecificResourceApplicable">
                                    <div class="mt-5">
                                        <app-checkbox
                                            [formControl]="classForm.controls['isBookingRequiresSpecificResource']"
                                            [disabled]="isBookingRequiresSpecificResourceDisabled"
                                            [label]="'GroupClassSave.IsBookingRequiresSpecificResource' | translate">
                                        </app-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-9-px">
                                <div class="col-auto ml-2 pr-1 align-self-center">
                                    <div class="booking-window-checkbox-input">
                                        <app-checkbox [formControl]="classForm.controls['isBookingWindowApplicable']"
                                            [label]="'GroupClassSave.BookingWindowLabel' | translate"></app-checkbox>
                                    </div>
                                </div>
                                <div class="col-auto px-0">
                                    <div class="form-group booking-window-value-input">
                                        <label
                                            for="bookingWindowValue">{{'GroupClassSave.BookingWindowValue' | translate}}</label>

                                        <input id="bookingWindowValue" class="form-control control-height"
                                            [formControl]="classForm.controls['bookingWindowValue']" type="number"
                                            min="1" step="1" max="99999" numbersOnly="99999"
                                            [ngClass]="{'is-disabled': !isBookingWindowApplicable}"
                                            [readonly]="!isBookingWindowApplicable"
                                            [required]="isBookingWindowApplicable" />
                                    </div>
                                </div>
                                <div class="col-auto ">
                                    <div class="booking-window-value-input">
                                        <label
                                            for="bookingWindowUnitCode">{{'GroupClassSave.BookingWindowUnit' | translate}}</label>

                                        <bcu-drop-down-cf2 id="bookingWindowUnitCode" class="control-height"
                                            [formControl]="classForm.controls['bookingWindowUnitCode']"
                                            [options]="context.bookingWindowUnits" valueKey="code" displayKey="name"
                                            [isDisabled]="!isBookingWindowApplicable"
                                            [required]="isBookingWindowApplicable" [sortItems]="true">
                                        </bcu-drop-down-cf2>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-9-px">
                                <div class="col mx-3 waitlist-row">
                                    <div class="booking-window-checkbox-input">
                                        <app-checkbox [formControl]="classForm.controls['isWaitListAllowed']"
                                            [label]="'GroupClassSave.WaitListLabel' | translate"></app-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>


                    <div class="row mt-3" *ngIf="isLoaded">
                        <div class="col text-center mx-3 buttons-row">
                            <button class="btn bc-button mr-2 mt-3" (click)="onClose()"
                                translate>GroupClassSave.ClassCancel</button>
                            <button class="btn btn-success ml-2 mt-3" (click)="onSave()" [disabled]="isGroupClassSaving"
                                translate>GroupClassSave.ClassSave</button>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>